<script>
	import { env as public_env } from '$env/dynamic/public';
	import { goto } from '$app/navigation';
	import { onDestroy, onMount } from 'svelte';
	import { variables } from '$lib/variables';
	import { fade, fly } from 'svelte/transition';
	import { lang } from '$lib/translations/cartproduct';
	import { page } from '$app/stores';
	export let OpenSearch;
	let results = [];

	let query = '';
	async function getSearch() {
		let url = `${variables.basePathApi}/api/v1/products-atributes/search/?search=${query}`;

		const res = await fetch(url);
		let resv = await res.json();

		results = resv;
	}
	onMount(async () => {
		// document.body.classList.add('modal-open');
		// window.scrollTo({ top: 0, behavior: 'smooth' });
		let url = `${variables.basePathApi}/api/v1/products-atributes/search/?search=су`;

		const res = await fetch(url);
		let resv = await res.json();

		results = resv;
	});
	onDestroy(() => {
		// Ваш код для закрытия модального окна
		document.body.classList.remove('modal-open');
	});
	function OpPage(item) {
		OpenSearch = false;

		return goto(`/${item.product.category.slug}/${item.id}`);
	}
	$: if (query) {
		setTimeout(() => {
			getSearch();
		}, 100);
	}
</script>

<div class="relative z-[2000]" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
	<!-- Background backdrop, show/hide based on slide-over state. -->
	<div class="fixed inset-0" />

	<div class="fixed inset-0 overflow-hidden">
		<div class="absolute inset-0 overflow-hidden">
			<div class="pointer-events-none fixed inset-y-0 right-0 flex pl-10 sm:pl-16">
				<div class="pointer-events-auto w-screen min-w-full">
					<div
						transition:fly={{
							y: -200,
							duration: 500
						}}
						class="flex h-full flex-col overflow-y-scroll bg-white shadow-xl"
					>
						<div class="p-2">
							<div class="flex items-start justify-between">
								<form class="w-full">
									<label
										for="default-search"
										class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
										>Поиск</label
									>
									<div class="relative">
										<div
											class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
										>
											<svg
												class="w-4 h-4 text-gray-500 dark:text-gray-400"
												aria-hidden="true"
												xmlns="http://www.w3.org/2000/svg"
												fill="none"
												viewBox="0 0 20 20"
											>
												<path
													stroke="currentColor"
													stroke-linecap="round"
													stroke-linejoin="round"
													stroke-width="2"
													d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
												/>
											</svg>
										</div>
										<input
											bind:value={query}
											type="search"
											id="default-search"
											class="block w-full p-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
											placeholder={lang[$page.data.host]['nameserarch']}
											required
										/>
										<button
											on:click={() => {
												OpenSearch = false;
											}}
											type="submit"
											class="text-white absolute end-2.5 bottom-2.5 bg-gray-700 hover:bg-gray-500 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
											>{lang[$page.data.host]['otmena']}</button
										>
									</div>
								</form>

								<div class="ml-3 flex h-7 items-center" />
							</div>
						</div>

						<ul role="list" class="flex-1 divide-y divide-gray-200 overflow-y-auto">
							{#each results as item}
								<!-- svelte-ignore a11y-click-events-have-key-events -->
								<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
								<li
									on:click={() => {
										OpPage(item);
									}}
								>
									<div class="group relative flex items-center justify-between px-5 py-6">
										<!-- Selected: "font-semibold" -->
										<div class="flex flex-col">
											<span class="text-gray-600">{item.product[`name${$page.data.host}`]}</span>
											<div class="inline-flex text-sm mt-2">
												<span class="text-custom-gray">
													{#if !lang}
														Категория:
													{/if}
												</span>
												<span class:ml-3={!lang} class="text-custom-gray"
													>{item.product.category[`name${$page.data.host}`]}</span
												>
											</div>

											{#if item.product.brand}
												<div class="inline-flex text-sm">
													<span class="text-custom-gray">
														{#if !lang}
															Бренд:
														{/if}
													</span>
													<span class:ml-3={!lang} class="text-custom-gray"
														>{item.product.brand.name}</span
													>
												</div>
											{/if}
										</div>

										<img
											style="height: 100px; width:auto"
											height="80"
											width="auto"
											src="{item.photos[0].image_thumbnail}"
											alt=""
										/>
									</div>
								</li>
							{/each}
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<style>
	/* :global(body){
        overflow: hidden;
    } */
</style>
